import { Theme, css } from '@emotion/react'
import styled from '@emotion/styled'

export const SectionStyled = styled.section((props) => {
    return {
        backgroundColor: props.theme.sections.servicePresentation.background,
    }
})

export const ContentWrapperStyled = styled.div((props) => {
    return {
        padding: props.theme.spacing(5, 0),
        display: 'flex',
        flexDirection: 'column',
        // maxWidth: props.theme.spacing(83),
        // [props.theme.breakpoints.down(props.theme.breakpoints.tablet)]: {
        //   maxWidth: props.theme.spacing(78),
        // },
        [props.theme.breakpoints.down(props.theme.breakpoints.md)]: {
            padding: props.theme.spacing(3, 0, 0, 0),
        },
    }
})

export const titleStyle = (theme: Theme) =>
    css({
        fontFamily: theme.fonts.default,
        color: theme.sections.servicePresentation.foreground,
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '48px',
        lineHeight: '50px',
        marginBottom: theme.spacing(3),
    })

export const DescriptionStyled = styled.p((props) => {
    return {
        fontFamily: props.theme.fonts.default,
        color: props.theme.sections.servicePresentation.foreground,
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '23px',
    }
})

export const ImageWrapperStyled = styled.div((props) => {
    return {}
})
